import request from '@/utils/request';

// Country查询列表分页
export const GetPageTableColumnItem = parameter => request.get('/country/select-country-by-currency-page', { params: parameter });